import GeneralNotice from '@pelckmans/elementis/components/general-notice';
import { useTranslation } from 'react-i18next';

export function ExerciseCalculating() {
  const { t } = useTranslation();

  return (
    <GeneralNotice
      className="exercise-general-notice"
      data-testid="exercise-calculating"
      text={t('EXERCISE_MANAGER.EXERCISE_CALCULATING.TITLE')}
      subText={
        <>
          {t('EXERCISE_MANAGER.EXERCISE_CALCULATING.P1')}
          <br />
          {t('EXERCISE_MANAGER.EXERCISE_CALCULATING.P2')}
        </>
      }
      spinner
    />
  );
}
